import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { Scrollbars } from "react-custom-scrollbars";
import { read } from "Helpers/LocalStorage";
import MenuItems from "Constants/MenuItems";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { NavLink } from "react-router-dom";
import Logo from "Assets/svg/logo/logo.svg";
import { SET_MENU_DRAWER } from "Stores/actionTypes";
import { ToolBarMenu } from "Constants/ToolBarMenu";
import { Link } from "react-router-dom";

function SideDrawer() {
  const dispatch = useDispatch();
  let StypeU = read("StypeU");
  let menuList = [...MenuItems.Category];
  const { selectedProject, menuStatus } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    menuStatus: state.auth.menuStatus,
  }));
  const [menuItems, setMenuItems] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [sizeChange, setSizeChange] = useState(true);

  const supic = ToolBarMenu.dashboard.find(
    (item) => item.menu_title === "support",
  );

  useEffect(() => {
    setSizeChange(window.innerWidth > 576 ? true : false);
    window.onresize = () => {
      setSizeChange(window.innerWidth > 576 ? true : false);
    };
  }, []);

  useEffect(() => {
    setOpenDrawer(menuStatus);
  }, [menuStatus]);

  useEffect(() => {
    let menuListNew = menuList
      .filter((item) => item.enable)
      .filter((mn) => mn.userAccess.includes(StypeU));
    menuListNew.map((item) => {
      if (item.menu_title === "patterns") {
        item.authorize = !!read("templateRules");
        return null;
      }
      // if (item.menu_title === "construction") {
      //   item.authorize = !!read("constructCutList") || !!read("constructGlass")  ;
      //   return null;
      // }
      if (item.menu_title === "properties") {
        item.authorize =
          !!read("addSeriProfileRules") ||
          !!read("mahsoleShisheRules") ||
          !!read("khadamatRules") ||
          !!read("yaraghRules") ||
          !!read("fomMasticRules") ||
          !!read("rokubRules") ||
          !!read("khadamatRules");
        return null;
      }
      if (
        item.menu_title === "statistic" &&
        (read("StypeU") === "2" || read("StypeU") === "5")
      ) {
        item.authorize = !!read("statisticsRules");
        return null;
      }
      // if (item.menu_title === "contract") {
      //   item.authorize = !!read("contractRules");
      //   return null;
      // }
    });
    const lists = menuListNew.map((menu) => {
      if (
        ((!selectedProject || selectedProject === "undefined") &&
          (menu.menu_title === "design" ||
            menu.menu_title === "invoices" ||
            menu.menu_title === "contract" ||
            menu.menu_title === "construction" ||
            menu.menu_title === "profit")) ||
        !menu.authorize
      ) {
        return (
          <>
            <ListItem
              key={`LI-${Date.now()}-${menu.menu_title}`}
              className="listItem disabled"
            >
              <ListItemIcon>
                <i className="drawerIcon material-icons">
                  <ReactSVG src={menu.menu_icon} />
                </i>
              </ListItemIcon>
              <ListItemText
                className="drawerText"
                primary={<Translator id={menu.menu_title} />}
              />
            </ListItem>
          </>
        );
      } else if (
        menu.menu_title === "design" &&
        read("isLockProject") &&
        read("StypeU") === "2"
      ) {
        return (
          <>
            <ListItem
              key={`LI-${Date.now()}-${menu.menu_title}`}
              className="listItem disabled"
            >
              <ListItemIcon>
                <i className="drawerIcon material-icons">
                  <ReactSVG src={menu.menu_icon} />
                </i>
              </ListItemIcon>
              <ListItemText
                className="drawerText"
                primary={<Translator id={menu.menu_title} />}
              />
            </ListItem>
          </>
        );
      } else {
        return (
          <NavLink
            key={`LI-${Date.now()}-${menu.menu_title}`}
            activeClassName="itemActive"
            to={menu.path}
          >
            <ListItem className="listItem">
              <ListItemIcon>
                <i className="drawerIcon material-icons">
                  <ReactSVG src={menu.menu_icon} />
                </i>
              </ListItemIcon>
              <ListItemText
                className="drawerText"
                primary={<Translator id={menu.menu_title} />}
              />
            </ListItem>
          </NavLink>
        );
      }
    });
    setMenuItems(lists);
  }, [selectedProject]);

  const onCloseDrawer = () => {
    setOpenDrawer(false);
    dispatch({ type: SET_MENU_DRAWER, status: false });
  };

  return (
    <>
      <Drawer
        variant={`${sizeChange ? "permanent" : ""}`}
        anchor={"left"}
        open={sizeChange ? true : openDrawer}
        onMouseDown={onCloseDrawer}
      >
        <div className="logoSection">
          <ReactSVG src={Logo} className="logo" />
        </div>
        <Scrollbars
          className="rct-scroll"
          autoHide
          autoHideDuration={100}
          //$headerHeight
          style={{
            height: "calc(100vh - 40px)",
            direction: "ltr",
            overflowX: "hidden",
          }}
        >
          <List className="list">{menuItems}</List>
          <div className="drawer-footer">
            <Link to={supic.path} className="drawer-footer-item">
              {supic.menu_icon}
              <Translator id={supic.menu_title} />
            </Link>
          </div>
        </Scrollbars>
      </Drawer>
    </>
  );
}

export default SideDrawer;
